import React from 'react'
import Image from 'next/image'

interface Props {
    item: {
        tag: string,
        title: string,
        image: string
    }
}

const AssortmentCard: React.FC<Props> = ({ item }) => {
    return (
        <div draggable style={{ cursor: 'default' }} className='megaschool__card'>
            <svg className='megaschool__card-hover' width="356" height="314" viewBox="0 0 356 314" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g style={{ mixBlendMode: 'screen' }} opacity="0.6">
                    <ellipse cx="178" cy="157" rx="178" ry="157" fill="url(#paint0_radial_4099_2135)" />
                </g>
                <defs>
                    <radialGradient id="paint0_radial_4099_2135" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(177 205) rotate(-54.8579) scale(218.9 166.771)">
                        <stop stop-color="#F47F54" stop-opacity="0.6" />
                        <stop offset="1" stop-color="#3F368A" stop-opacity="0" />
                    </radialGradient>
                </defs>
            </svg>
            <div className="megaschool__card-top">
                <p className="megaschool__card-tag categories-slider__text">{item.tag}</p>
                <h3 className="megaschool__card-title">{item.title}</h3>
            </div>
            <Image
                className='megaschool__card-image'
                src={item.image}
                width={356}
                height={323}
                alt='product' />
        </div>
    )
}

export default AssortmentCard
